import { unbindSocketChannel } from '@legacyApp/client/store/websocket/websocket.actions';
import { WEBSOCKET_CHANNELS } from '@legacyApp/client/store/websocket/websocket.constants';
import { config } from '@legacyApp/client/config';
import { AppThunk } from '@legacyApp/types/store/ThunkAction';
import { unbindStreams } from '../chat.constants';
import { chatActions } from '../chat.actions';

export const unbindChatStreamActionThunk = (room): AppThunk => {
	return (dispatch) => {
		unbindStreams.reset(room);
		unbindStreams.setTimeout(
			room,
			() => {
				dispatch(chatActions.setStream({ room, list: [] }));
				dispatch(unbindSocketChannel(`${WEBSOCKET_CHANNELS.CHAT}.${room}`));
			},
			config.chat.clearRoomTimeout,
		);
	};
};
